// Pure list helpers for drag and drop. Both return the original array when the
// move is impossible, so callers can treat an unchanged reference as a no-op.

export const moveWithinList = (tasks, sourceIndex, destinationIndex) => {
  const next = [...tasks]
  const [moved] = next.splice(sourceIndex, 1)
  if (!moved) return tasks
  next.splice(destinationIndex, 0, moved)
  return next
}

export const moveBetweenLists = (sourceTasks, destinationTasks, sourceIndex, destinationIndex) => {
  const source = [...sourceTasks]
  const destination = [...destinationTasks]
  const [moved] = source.splice(sourceIndex, 1)
  if (!moved) return { source: sourceTasks, destination: destinationTasks }
  destination.splice(destinationIndex, 0, moved)
  return { source, destination }
}
